import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'mojo-job-salary-direct',
  templateUrl: './job-salary-direct.component.html',
  styleUrls: ['./job-salary-direct.component.scss'],
})
export class JobSalaryDirectComponent {
  @Input() form: UntypedFormGroup;
}
